import { LogLevel } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: '56478c37-f65d-4b60-aee8-ebe730fba31f',
    authority: 'https://login.microsoftonline.com/249dc4fd-776e-4bad-9ed5-961473817692/',
    redirectUri: 'https://admin-qa-dev.foodbusiness.services',
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      }
    }
  }
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email']
};